import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorICData = (data) => {
  const itemsArr = data.icItemsRep ? get(data, 'icItemsRep', []) : [];
  const newData = {
    heading: get(data, 'icHeading', null),
    items: itemsArr.map((item, index) => {
      const icon = item.icItemsRepIcon ? refactorRespImg(item.icItemsRepIcon, [{
        size: 'default',
        key: 'image_size_160x160'
      },{
        size: 'md',
        key: 'image_size_196x196',
      },{
        size: 'lg',
        key: 'image_size_280x280',
      }]) : null;
      return {
        id: `icItemsRep_${index}`,
        icon,
        text: get(item, 'icItemsRepText', null)
      }
    })
  }

  return newData
}

export default refactorICData